// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const foundry = defineModel({
  id: "foundry",
  batchId: "future",
  name: "Foundry",
  tags: ["building","foundry","low-poly","age-of-mcp","future"],
  summary: "Casts molten metal into parts, tools and fittings for the whole settlement.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.5, 1.15), color: "#9c4a32", position: [0, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a3826", position: [-0.75, 0.39, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a3826", position: [0.75, 0.39, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a3826", position: [-0.75, 0.39, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a3826", position: [0.75, 0.39, 0.575] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.8, 0.5, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.8, 0.5, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.8, 0.5, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.8, 0.5, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 1.05, 1.15), color: "#9c4a32", position: [0, 0.665, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [-0.75, 0.665, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [0.75, 0.665, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [-0.75, 0.665, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [0.75, 0.665, 0.575] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.8, 0.8, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.8, 0.8, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.8, 0.8, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.8, 0.8, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 1.05, 1.15), color: "#9c4a32", position: [0, 0.665, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [-0.75, 0.665, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [0.75, 0.665, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [-0.75, 0.665, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 1.05, 0.1), color: "#7a3826", position: [0.75, 0.665, 0.575] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.810483), color: "#4a5258", position: [0, 1.39, 0.3175], rotation: [0.56213, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.810483), color: "#4a5258", position: [0, 1.39, -0.3175], rotation: [-0.56213, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#5a3526", position: [0, 1.59, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 1.1, 0.24), color: "#7a3826", position: [0.46, 1.39, -0.2] },
      { geometry: new THREE.BoxGeometry(0.3, 0.07, 0.3), color: "#9c4a32", position: [0.46, 1.97, -0.2] },
      { geometry: new THREE.SphereGeometry(0.14, 6, 5), color: "#9a9a96", position: [0.46, 2.14, -0.2], scale: [1, 0.6, 1] },
      { geometry: new THREE.SphereGeometry(0.17, 6, 5), color: "#b0b0ac", position: [0.52, 2.37, -0.16], scale: [1, 0.6, 1] },
      { geometry: new THREE.BoxGeometry(0.34, 0.36, 0.06), color: "#f0902c", position: [0, 0.34, 0.585] },
      { geometry: new THREE.CylinderGeometry(0.17, 0.17, 0.06, 8, 1, false, 0, 3.141593), color: "#f0902c", position: [0, 0.52, 0.585], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.42, 0.05), color: "#3c4146", position: [0, 0.36, 0.555] },
    ] },
  ],
  animations: [],
});
